import { styled } from "@mui/material";
const StyledWrapper = styled("div")(() => ({
  padding: "3px 2.5px",
  width: "min-content"
})), StyledContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  color: theme.palette.white.main,
  height: "18px",
  minWidth: "19px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 6px",
  boxSizing: "border-box"
}));
export {
  StyledContainer,
  StyledWrapper
};
//# sourceMappingURL=styles.js.map
